import request from "../utils/request";
//获取设计师列表
export function getDesignerList(params, number = 1) {
  return request({
    url: `/designer/list?queryType=${number}&pageNum=${
      params.pageNum
    }&pageSize=${params.pageSize}&name=${params.name}&tags=${
      params.tags ? params.tags : ""
    }&status=${params.status ? params.status : ""}&introduction=${
      params.introduction
        ? params.introduction
        : params.introduction == 0
        ? params.introduction
        : ""
    }&isAuth=${
      params.isAuth ? params.isAuth : params.isAuth == 0 ? params.isAuth : ""
    }&type=${params.type}`,
    method: "get"
  });
}
//更具id查询设计师列表
export function getDesignerById(params) {
  return request({
    url: `/designer/getById?id=${params.id}`,
    method: "get",
  });
}
//查看所有类型
export function getDesignerSelectAllType() {
  return request({
    url: `/designer/selectAllType`,
    method: "get"
  });
}
//新增数据
export function designerCreate(params) {
  return request({
    url: `/designer/add`,
    method: "post",
    data: {
      designerCO: Object.assign(params, {
        img: params.backgroundUrl, //头像
        category: params.tagList.join(","), //分类，多个以英文逗号隔开
        country: JSON.stringify(params.country), //国家
        androidApiVersion: JSON.stringify(params.androidApiVersion), //安卓版本
        iosApiVersion: JSON.stringify(params.iosApiVersion), //ios版本
        appVersion: JSON.stringify(params.appVersion) //app版本
      })
    }
  });
}
//编辑数据
export function designerUpdate(params) {
  return request({
    url: `/designer/update`,
    method: "post",
    data: {
      designerCO: Object.assign(params, {
        id: params.id,
        img: params.backgroundUrl, //头像
        category: params.tagList.join(","), //分类，多个以英文逗号隔开
        country: JSON.stringify(params.country), //国家
        androidApiVersion: JSON.stringify(params.androidApiVersion), //安卓版本
        iosApiVersion: JSON.stringify(params.iosApiVersion), //ios版本
        appVersion: JSON.stringify(params.appVersion) //app版本
      })
    }
  });
}
//删除设计师
export function DesignerDelete(params) {
  return request({
    url: `/designer/delete`,
    method: "post",
    data: {
      id: params.id
    }
  });
}
//上下线接口
export function onOrOff(params) {
  return request({
    url: `/designer/onOrOff`,
    method: "post",
    data: {
      id: params.id
    }
  });
}

//设计师关联资源列表
export function listWallpaperById(params) {
  return request({
    url: `/designer/listWallpaperById?pageNum=${params.currentPage}&pageSize=${
      params.currentPageSize
    }&designerId=${params.id}&wallpaperName=${params.name}&wallpaperType=${
      params.type
    }&wallpaperStatus=${params.status ? params.status : ""}`,
    method: "get"
  });
}

//认证取消认证
//设计师关联资源列表
export function designerAuth(params) {
  return request({
    url: `/designer/auth`,
    method: "post",
    data: params
  });
}
